import React from "react";
import { PulsePageControlContentProps } from "@features/pulse/utils/types";
import PulseMobileCarousel from "@features/pulse/variant/control/components/PulseMobileCarousel/PulseMobileCarousel";

/**
 * PulseMobilePage is a React component that renders the mobile version of the Pulse variant control.
 */
export default function PulseMobilePage({
  sortedPulseArticles,
  activeArticle,
  handleSetActiveArticle,
  backToBt = "/",
}: PulsePageControlContentProps): React.ReactElement {
  if (sortedPulseArticles.length === 0) return <></>;

  return (
    <div
      data-testid="pulse-mobile-page"
      className="block h-full w-full lg:hidden"
    >
      <PulseMobileCarousel
        sortedPulseArticles={sortedPulseArticles}
        activeArticle={activeArticle}
        backToBt={backToBt}
        handleSetActiveArticle={handleSetActiveArticle}
      />
    </div>
  );
}
